(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const groups = [...document.querySelectorAll('.luxsol-footer__column')].map(column => ({
    toggle: column.querySelector('.luxsol-footer__toggle'),
    label: column.querySelector('.luxsol-footer__heading-static'),
    links: column.querySelector('ul'),
    expanded: false
  })).filter(group => group.toggle && group.label && group.links);

  function render() {
    groups.forEach(group => {
      group.toggle.hidden = !mobile.matches;
      group.label.hidden = mobile.matches;
      const collapsed = mobile.matches && !group.expanded;
      if (collapsed && group.links.contains(document.activeElement)) group.toggle.focus();
      if (!mobile.matches && document.activeElement === group.toggle) group.links.querySelector('a')?.focus();
      group.links.hidden = collapsed;
      group.toggle.setAttribute('aria-expanded', String(mobile.matches ? group.expanded : true));
    });
  }

  groups.forEach(group => group.toggle.addEventListener('click', () => {
    group.expanded = !group.expanded;
    render();
  }));
  mobile.addEventListener('change', render);
  render();
})();

// Preserve the native chat launcher, but never let it cover mobile copy or controls.
(() => {
  if (!document.body.classList.contains('luxsol-homepage')) return;
  const mobile = window.matchMedia('(max-width: 749px)');
  const className = 'lh-chat-obstructs-content';
  const targets = document.querySelectorAll(
    'main :is(a, button, h1, h2, h3, p, summary, figcaption, dt, dd), ' +
    '.luxsol-footer :is(a, button, p)'
  );
  const visibleTargets = new Set();
  let frame = 0;
  let activator;

  // Use the exposed activator part, without changing the widget's internals.
  function findActivator(root) {
    if (!root) return null;
    const part = root.querySelector('[part~="activator"]');
    if (part) return part;
    for (const element of root.querySelectorAll('[exportparts]')) {
      const nested = findActivator(element.shadowRoot);
      if (nested) return nested;
    }
    return null;
  }

  function update() {
    frame = 0;
    const chat = document.querySelector('shopify-chat');
    if (!mobile.matches || !chat) {
      document.body.classList.remove(className);
      return;
    }
    if (!activator?.isConnected) activator = findActivator(chat.shadowRoot);
    if (!activator || activator.matches(':focus-visible') ||
        activator.getAttribute('aria-expanded') === 'true') {
      document.body.classList.remove(className);
      return;
    }
    const launcher = activator.getBoundingClientRect();
    const gap = 8; // Clearance includes the widget's small idle movement.
    const overlaps = launcher.width > 0 && launcher.height > 0 &&
      [...visibleTargets].some(element => [...element.getClientRects()].some(rect =>
        rect.width > 0 && rect.height > 0 &&
        rect.left < launcher.right + gap && rect.right > launcher.left - gap &&
        rect.top < launcher.bottom + gap && rect.bottom > launcher.top - gap
      ));
    document.body.classList.toggle(className, overlaps);
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) visibleTargets.add(entry.target);
      else visibleTargets.delete(entry.target);
    }
    schedule();
  });
  targets.forEach(target => observer.observe(target));
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('click', schedule);
  mobile.addEventListener('change', schedule);
  document.fonts?.ready.then(schedule);
  // Inbox loads asynchronously, independently of the theme's script.
  customElements.whenDefined('shopify-chat').then(() => {
    schedule();
    [250, 1000, 3000].forEach(delay => setTimeout(schedule, delay));
  });
  schedule();
})();
